<div class="slot-column">
    @if (!selectedState) {
    <div class="no-state-selected">
        <mat-icon>chevron_left</mat-icon>
        <p>Select a state to edit its slot layout.</p>
    </div>
    } @else {
    <div class="slot-editor">
        <div class="slot-editor-header">
            <div>
                <h3>{{ selectedState }}</h3>
                <p class="slot-editor-hint">Add all slots, then save the layout. Images are uploaded on save.</p>
            </div>
            <div class="height-total" [class.valid]="isHeightValid">
                <mat-icon>{{ isHeightValid ? 'check_circle' : 'warning' }}</mat-icon>
                Total: {{ heightPercentTotal }}%
                @if (!isHeightValid) {
                <span class="height-warn">must equal 100%</span>
                }
            </div>
        </div>
        <!-- transientDurationSeconds section -->
        <div class="transient-duration-section">
            <mat-form-field appearance="fill" class="transient-duration-field">
                <mat-label>Transient Duration (seconds)</mat-label>
                <input matInput type="number" min="0" [(ngModel)]="editingTransientDuration" />
                <mat-hint>Optional duration for transient states. Leave blank for default.</mat-hint>
            </mat-form-field>
        </div>
        <div class="slots-list">
            @for (entry of orderedSlots(); track entry.trackKey) {
            <app-slot-edit-item [slot]="entry.slot" [index]="$index" [slotTypes]="slotTypes"
                [pendingImageFile]="getPendingFile(entry.sourceIndex)"
                (fieldChange)="updateField(entry.sourceIndex, $event.field, $event.value)"
                (remove)="removeSlot(entry.sourceIndex)"
                (imageFileSelected)="setPendingImage(entry.sourceIndex, $event)" />
            } @empty {
            <p class="no-slots-hint">No slots yet. Add all slots for this state, then save.</p>
            }
        </div>

        <div class="slot-editor-footer">
            <button mat-stroked-button (click)="addSlot()">
                <mat-icon>add</mat-icon> Add Slot
            </button>
            <button mat-raised-button color="primary" [disabled]="!canSave" [matTooltip]="saveTooltip"
                (click)="submit()">
                <mat-icon>save</mat-icon> Save Layout
            </button>

        </div>
        <!-- Error message container -->
        @if (errorMessage) {
        <div class="error-message">
            <mat-icon>error</mat-icon>
            <span>{{ errorMessage }}</span>
        </div>
        }
    </div>
    }
</div>